import { useEffect, useId, type RefObject } from 'react'
import { linkCaptionLabel } from './fieldAssociation'

/**
 * Gives a shared input the name of the plain `<label>` drawn above it when no
 * htmlFor, aria-label or FieldLabel names it (Q4-BRES7, Q4-BFIN9, Q5-BPHONE2).
 * Runs after every render because the caption can mount later than the input;
 * the check is a couple of sibling look-ups and a no-op once named.
 */
export function useCaptionLabel(ref: RefObject<HTMLElement | null>) {
  const base = useId()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    linkCaptionLabel(ref.current as never, () => `${base}-caption`)
  })
}
